const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/users/Login",
    REGISTER: "/users/Register",
    ForgotPassword: "/users/ForgotPassword",
    ResetPassword: "/users/ResetPassword",
    ChangePassword: "/users/ChangePassword",
    REFRESH_TOKEN: "/auth/refresh-token",
    LOGOUT: "/users/Logout",
    ME: "/users/Me",
  },

  DASHBOARD: {
    SUMMARY: "/users/Dashboard/Summary",
    BONUS_INCENTIVE: "/users/Dashboard/BonusIncentive",
  },

  PAYROLL: {
    HEADERS: "/Payroll/headers",
    EMPLOYEES: (headerId) => `/Payroll/${headerId}/employees`,
    DASHBOARD: "/Payroll/Dashboard",
    GET_EMPLOYEES_PAYROLL_DETAILS: "/Payroll/PayrollPreview",
    GET_EMPLOYEE_BY_ID: (id) => `/Payroll/employee/${id}`,
    CREATE_EMPLOYEE: "/Payroll/employee",
    PAYROLL_PENDING_PAYMENY: "/Payroll/PendingPayments",
    CALCULATE: `/Payroll/RunPayrollBatch`,
    EXPORT: (headerId) => `/Payroll/${headerId}/export`,
    GENERATE_PAYCHECK: (employeeId) =>
      `/Payroll/Employee/${employeeId}/Paycheck`,
    UPDATE_EMPLOYEES_WORK_DETAILS: (headerId) =>
      `/Payroll/header/${headerId}/Employees/WorkDetails`,
  },

  PAYROLL_PAYMENT: {
    BATCH_HISTORY: "/PayrollPayment/BatchHistory",
    EMPLOYEE_BATCH_HISTORY: "/PayrollPayment/EmployeeBatchHistory",
    EXPORT_DAILY_CSV: "/PayrollPayment/exportPayrollHistoryCsv",
    PROCESS_DIRECT_DEPOSIT: (payrollHeaderId) =>
      `/PayrollPayment/ProcessDirectDeposit/${payrollHeaderId}`,
    NOTIFY_FAILED_PAYMENTS: (batchId) =>
      `/PayrollPayment/NotifyFailedPayments/${batchId}`,
    PAY_TAX: "/PayrollPayment/TaxPay",
    TAX_STATUS: "/PayrollPayment/TaxStatus",
    TAX_EXPORT: "/PayrollPayment/TaxStatus/ExportCsv",
  },

  USER: {
    GET_ALL_CLIENTS: "/users/GetAllClients",
    GET_ALL_COMPANIES: "/users/GetAllCompanies",
    GET_ALL_EMPLOYEES: "/users/GetAllEmployees",
    GET_ALL: "/users/GetAll",
    GET_BY_ID: (id) => `/users/GetById/${id}`,
    GET_COMPANY_BY_ID: (id) => `/users/GetCompanyById/${id}`,
    GET_EMPLOYEE_BY_ID: (id) => `/users/GetEmployeeById/${id}`,
    GET_DASHBOARD: "/users/Dashboard/Summary",
    GET_BONUS_INCENTIVE: "/users/Dashboard/BonusIncentive",

    CREATE_CLIENT: "/users/CreateClient",
    CREATE_COMPANY: "/users/CreateCompany",
    CREATE_EMPLOYEE: "/users/CreateEmployee",

    SAVE_BANK_DETAILS: (userId) => `/users/SaveBankDetails/${userId}`,
    REMOVE_BANK: (userId, paymentMethodId) =>
      `/users/RemoveBank/${userId}/${paymentMethodId}`,

    UPDATE: (id) => `/users/UpdateUser/${id}`,
    UPDATE_EMPLOYEE: (id) => `/users/UpdateEmployee/${id}`,
    UPDATE_COMPANY: (id) => `/users/UpdateCompany/${id}`,
    UPDATE_COMPANY_STATUS: "/users/UpdateCompanyStatus",

    DELETE: (id, roleName) => `/users/Delete/${id}/${roleName}`,
    DELETE_COMPANY: (id) => `/users/DeleteCompany/${id}`,
    DELETE_EMPLOYEE: (id) => `/users/DeleteEmployee/${id}`,

    EXPORT_CLIENTS_CSV: "/users/Clients/ExportCsv",
    EXPORT_COMPANIES_CSV: `/users/Companies/ExportCsv`,
    EXPORT_EMPLOYEES_CSV: `/users/Employees/ExportCsv`,
  },

  FORMULA: {
    GET_ALL_FORMULAS: "/Formula/GetAll",
    GET_BY_ID: (id) => `/Formula/GetById/${id}`,
    CREATE_FORMULA: "/Formula/Create",
    UPDATE_FORMULA: (id) => `/Formula/Update?id=${id}`,
    DELETE_FORMULA: (id) => `/Formula/Delete/${id}`,
  },

  Designation: {
    GET_ALL_DESIGNATIONS: "/Designation/GetAll",
    CREATE_DESIGNATIONS: "/Designation/Create",
    UPDATE_DESIGNATIONS: (id) => `/Designation/Update?id=${id}`,
    DELETE_DESIGNATIONS: (id) => `/Designation/Delete/${id}`,
  },

  Department: {
    GET_ALL_DEPARTMENTS: "/Department/GetAll",
    CREATE_DEPARTMENT: "/Department/Create",
    UPDATE_DEPARTMENT: (id) => `/Department/Update?id=${id}`,
    DELETE_DEPARTMENT: (id) => `/Department/Delete/${id}`,
  },

  Report: {
    PAYROLL_SUMMARY_REPORT: "/PayrollReports/PayrollSummaryReport",
    TAX_LIABILITY_REPORT: "/PayrollReports/TaxLiabilityReport",
  },

  City: {
    GET_ALL_CITIES: "/City/GetAll",
    GET_CITY_BY_ID: (id) => `/City/GetById?id=${id}`,
    CREATE_CITY: "/City/Create",
    UPDATE_CITY: (id) => `/City/Update/${id}`,
    DELETE_CITY: (id) => `/City/Delete/${id}`,
  },

  Country: {
    GET_ALL_COUNTRIES: "/Country/GetAll",
    GET_COUNTRY_BY_ID: (id) => `/Country/GetById?id=${id}`,
    CREATE_COUNTRY: "/Country/Create",
    UPDATE_COUNTRY: (id) => `/Country/Update/${id}`,
    DELETE_COUNTRY: (id) => `/Country/Delete/${id}`,
  },

  State: {
    GET_ALL_STATES: "/State/GetAll",
    GET_STATE_BY_ID: (id) => `/State/GetById?id=${id}`,
    CREATE_STATE: "/State/Create",
    UPDATE_STATE: (id) => `/State/Update/${id}`,
    DELETE_STATE: (id) => `/State/Delete/${id}`,
  },

  Notification: {
    GET_ALL: "/Notification/GetAllNotifications",
    CREATE: "/Notification/CreateNotification",
    MarkNotificationAsRead: (notificationId, userId) =>
      `/Notification/MarkNotificationAsRead?notificationId=${notificationId}&userId=${userId}`,
    MarkAllNotificationsAsRead: (userId, roleName) =>
      `/Notification/MarkAllNotificationsAsRead?userId=${userId}&role=${roleName}`,
  },

  Variable: {
    GET_ALL_VARIABLES: "/Variable/GetAll",
    CREATE_VARIABLE: "/Variable/Create",
    UPDATE_VARIABLE: (id) => `/Variable/Update/${id}`,
    DELETE_VARIABLE: (id) => `/Variable/Delete/${id}`,
  },

  VariableType: {
    GET_ALL_VARIABLE_TYPES: "/VariableType/GetAll",
    CREATE_VARIABLE_TYPE: "/VariableType/Create",
    UPDATE_VARIABLE_TYPE: (id) => `/VariableType/Update/${id}`,
    DELETE_VARIABLE_TYPE: (id) => `/VariableType/Delete/${id}`,
  },
};

export default API_ENDPOINTS;
